import { install } from "click-outside-vue3"

export default {
  state: {
    stepOrder: [
      'viability',
      'contract',
      'telephony',
      'documents',
      'payment',    
      'installation',  
      'scheduled'
    ],

    stepper: {
      viability: {
        routeName: 'Availability',
        completed: false
      },
      contract: {
        routeName: 'ContractData',
        completed: false
      },
      telephony: {
        routeName: 'Portability',
        completed: false
      },
      documents: {
        routeName: 'Documents',
        completed: false
      },
      payment: {
        routeName: 'Payment',
        completed: false
      },
      installation: {
        routeName: 'Installation',
        completed: false
      },
      scheduled: {
        routeName: 'Revision',
        completed: false
      }
    },

    activeStep: null
  },


  getters: {
    getActiveStep: state => state.activeStep,

    getStep: state => stepKey => state.stepper[stepKey] ?? null,

    getStepIndex: state => stepKey =>
      state.stepOrder.indexOf(stepKey),

    getStepByRouteName: state => routeName => {
      return (
        Object.entries(state.stepper)
        .find(([_, step]) => step.routeName === routeName)?.[0] ?? null
      )
    }
      
  },

  actions: {
    completeStepsUntil ({ state, dispatch }, stepKey) {
      const index = state.stepOrder.indexOf(stepKey)
      if (index === -1) return

      state.stepOrder.slice(0, index).forEach(key => {
        dispatch('updateStep', { stepKey: key, value: true })
      })
    },

    updateStep ({ commit }, payload) {
      commit('updateStep', payload)
    },

    setActiveStep ({ commit }, stepKey) {
      commit('setActiveStep', stepKey)
    }
  },

  mutations: {
    updateStep (state, { stepKey, value }) {
      if (!state.stepper[stepKey]) return
      state.stepper[stepKey].completed = value
    },

    setActiveStep (state, stepKey) {
      state.activeStep = stepKey
    }
  }
}
